import React from 'react'
import { Route, Redirect, useLocation } from 'react-router-dom'
import { authenticated, getCustomerUserId } from '../lib/utils/auth.utils'
import { setCookie } from 'react-use-cookie'
import CommonHeader from '../../components/layout/common-header'
import CommonFooter from '../../components/layout/common-footer'
import { BackTop } from 'antd'
import SaleOrderManagementForCustomer from '../../pages/order/sales-order/sales-order-management-for-customer'

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
export const ProtectedRoute = ({component: Component, ...rest}) => {
  const location = useLocation()

  return (
    <Route
      {...rest }
      render={
        (props) => {
          if (getCustomerUserId()) {
            return (
              <div style={{margin: '1rem'}}>
                <SaleOrderManagementForCustomer />
              </div>
            )
          }
          if (rest.path === '/' && !authenticated()) {
            return (
              <Component {...props} />
            )
          }
          if (rest.path === '/' && authenticated()) {
            // A token without the pages config is a broken session (e.g. the
            // token cookie was resurrected by an in-flight refresh after
            // logout): drop it and show the login page instead of bouncing
            // the user back into the app with an empty menu.
            if (!localStorage.getItem('pages')) {
              setCookie('token', '')
              return (
                <Component {...props} />
              )
            }
            window.location.href = '/home'
          }
          const pages: any = localStorage.getItem('pages')
          const isAuthPage = (
            location.pathname === '/home' ||
            location.pathname === '/' ||
            location.pathname !== '/' && location.pathname !== '/home' && (pages && JSON.parse(pages).filter((row: any) => row.pageUrl === location.pathname)[0])
          )
          if (authenticated() && !!pages && !!isAuthPage) {
            return (
              <div style={{display: 'flex', height: '100vh', flexDirection: 'column', width: '100%', minWidth: '1000px'}}>
                <CommonHeader />
                <div style={{
                  flex: 1, 
                  padding: '2rem 1.5rem 0 1.5rem' // 左右对称的padding
                }}>
                  <div style={{
                    margin: '0 auto',
                    width: '100%',
                    // maxWidth: '2000px',
                    minHeight: '720px'
                  }}>
                    <BackTop visibilityHeight={200} style={{right: '1.5rem', bottom: '7rem'}} />
                    <Component {...props} />
                  </div>
                </div>
                <CommonFooter />
              </div>
            )
          } else {
            return <Redirect to={
              {
                pathname: '/',
                state: {
                  from: props.location
                }
              }} />
          }
        }
      }
    />
  )
}
